import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'download-item',
  templateUrl: 'download-item.component.html',
  styleUrls: ['download-item.component.scss']
})
export class DownloadItemComponent {
  @Input() link: string;
  @Input() linkActive: boolean = false;
  @Input() nameIncompleted: string = 'PROCESSING';
  @Input() nameCompleted: string = 'DOWNLOAD';
  @Input() completed: boolean = false;
  @Input() inactive: boolean = false;
  @Input() isFailed: boolean = false;
  @Input() isWarning: boolean = false;
  @Input() isOnlyIcon: boolean = false;
  @Input() icon: string = 'download-icon';

  get isLinkAvailable(): boolean {
    return (this.completed && !this.inactive && !this.isFailed && !!this.link);
  }

  onLinkClick(event: any) {
    if (!this.isLinkAvailable && !this.linkActive) {
      event.preventDefault();
      return;
    }
  }
}
